import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {getAuth} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD8Iq2EmhGHwAgzzvVOe08o9csx3RoGDic",
  authDomain: "eventhub-468bf.firebaseapp.com",
  projectId: "eventhub-468bf",
  storageBucket: "eventhub-468bf.firebasestorage.app",
  messagingSenderId: "723011269939",
  appId: "1:723011269939:web:9b5309874fd24e5153fa46",
  measurementId: "G-BL8XEYSZYB"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth =getAuth(app);